import { TreeDiagramNodesList } from './nodesList.class';
import {AppTreeDiagramService } from '../../app-tree-diagram/app-tree-diagram.service';
import {AppTreeDiagramComponent } from '../../app-tree-diagram/app-tree-diagram.component';
import { Http } from '../../../../../node_modules/@angular/http';
 
export class TreeDiagramNode {
  public parentId: string | null;
  public guid: string;
  public width: number;
  public height: number;
  public isDragover: boolean;
  public isDragging: boolean;
  public Red: string;
  private _toggle: boolean;
  public children: Set<string>;
  public  isMaker: boolean;
  //DISPLAY STRINGS 
  public displayName: string;
  public Type: string;
  public Budget: number;
  public Number: string;
  public Total: number;
  public BU: number;
  public CC: string;
  public Account: string;
  public RFC: string;
  public visible = false;
  public cambios: any = [];
  public changed: boolean = false;

  //classes
  public AppTree = AppTreeDiagramComponent;


  constructor (private service: AppTreeDiagramComponent ,props, config, public getThisNodeList: () => TreeDiagramNodesList) {
   
    if (!props.guid) {
      return;
    }
    for (let prop in props) {
      if (props.hasOwnProperty(prop)) {
        this[prop] = props[prop]
      }
    }

    this._toggle = false;

    if (config.nodeWidth) {
      this.width = config.nodeWidth
    }
    if (config.nodeHeight) {
      this.height = config.nodeHeight
    }
    this.children = new Set(<string[]>props.children)
  }

  public changes()
  {
    console.log(this.cambios);
  }

  public destroy () {
    this.getThisNodeList().destroy(this.guid)
  }

  public get isExpanded () {
    return this._toggle
  }

  public hasChildren () {
    return !!this.children.size
  }
//////////////////////////////////////////////////////////
  public toggle (state = !this._toggle) {
    this._toggle = state;
    state && this.getThisNodeList().toggleSiblings(this.guid)
    this.visible = true;
  }
//////////////////////////////////////////////////////////
  public childrenCount () {
    return this.children.size
  }

  public isRoot () {
    return this.parentId == null;
  }

  public dragenter (event) { //se ejecuta al arrastrar el nodo dentro del área permitida nuevamente.
    event.dataTransfer.dropEffect = 'move';
  }

  public dragleave (event) { //se ejecuta al arrastrar el nodo fuera del área permitida. Puede cambiar si el nodo vuelva al área.
    this.isDragover = false;
  }

  public dragstart (event) { // se ejecuta al comenzar a arrastrar un nodo
    event.dataTransfer.effectAllowed = 'move';
    this.isDragging = true;
    this.toggle(false)
    this.getThisNodeList().draggingNodeGuid = this.guid
  }

  public dragover (event) { //se ejecuta al sostener un nodo sobre otro.
    event.preventDefault();
    if (!this.isDragging) {
      this.isDragover = true;
    }
    event.dataTransfer.dropEffect = 'move'
    return false;
  }

  public dragend(event){ //Se ejecuta al soltar un nodo fuera de otro, es decir, al cancelar la acción.
    this.isDragover = false;
    this.isDragging = false;
    
  }

  public drop (event) { //se ejecuta al soltar un nodo dentro de otro
    event.preventDefault();
    let guid = this.getThisNodeList().draggingNodeGuid;
    this.getThisNodeList().transfer(guid, this.guid);

    this.cambios.push
    ({
      inicio:guid,
      destino:this.guid
    });

    this.service.MoveNode(guid,this.guid);
    this.service.createRawTree();
    

    return false;
  }


  public addChild(){
    let newNodeGuid = this.getThisNodeList().newNode(this.guid)
    this.children.add(newNodeGuid)
    this.toggle(true)
  }






}



// WEBPACK FOOTER //
// ./src/app/components/angular2-tree-diagram/classes/node.class.ts